import { useEffect, useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export const InvestorTrack = ({ chapters, active, onSelect }) => {
  const viewportRef = useRef(null);
  useEffect(() => {
    const viewport = viewportRef.current;
    const node = viewport?.querySelector(`[data-track-index="${active}"]`);
    if (!viewport || !node) return;
    viewport.scrollTo({ left: node.offsetLeft - viewport.clientWidth / 2 + node.clientWidth / 2, behavior: "smooth" });
  }, [active]);

  return (
    <nav className="invest-cinematic-track" aria-label="Pitch chapters" data-testid="invest-chapter-navigation">
      <button type="button" onClick={() => onSelect(active - 1)} disabled={active === 0} aria-label="Previous chapter" data-testid="invest-previous-chapter"><ChevronLeft /></button>
      <div className="invest-track-status">
        <strong data-testid="invest-current-chapter-count">{String(active + 1).padStart(2, "0")}<span>/25</span></strong>
        <p data-testid="invest-current-chapter-label">{chapters[active].nav}</p>
      </div>
      <div className="invest-track-viewport" ref={viewportRef} data-lenis-prevent>
        <div className="invest-track-rail" style={{ "--track-progress": `${(active / (chapters.length - 1)) * 100}%` }}>
          {chapters.map((chapter, index) => (
            <button
              type="button"
              key={chapter.slug}
              onClick={() => onSelect(index)}
              aria-current={active === index ? "step" : undefined}
              aria-label={`${chapter.id}. ${chapter.nav}`}
              data-track-index={index}
              data-testid={`invest-nav-chapter-${chapter.id}`}
            ><i /><span>{chapter.nav}</span></button>
          ))}
        </div>
      </div>
      <button type="button" onClick={() => onSelect(active + 1)} disabled={active === chapters.length - 1} aria-label="Next chapter" data-testid="invest-next-chapter"><ChevronRight /></button>
    </nav>
  );
};